import {Separator} from 'platform/components';
import {Clickable, Heading, HStack, Icon, Show, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps, useToggle} from 'shared/web';

interface OlderReportsListProps extends TestIdProps {
  title: string;
  children: ReactNode;
}

export function OlderReportsList(props: OlderReportsListProps) {
  const [isOpen, toggleOpen] = useToggle();

  return (
    <>
      <Separator spacing={0} />

      <VStack spacing={4}>
        <Clickable onClick={toggleOpen} data-testid={suffixTestId('previousReportsToggle', props)}>
          <HStack justify="space-between" align="center">
            <Heading size={4}>{props.title}</Heading>
            <Icon value={isOpen ? 'navigation/expand_less' : 'navigation/expand_more'} size={4} />
          </HStack>
        </Clickable>

        <Show when={isOpen}>
          <VStack>{props.children}</VStack>
        </Show>
      </VStack>
    </>
  );
}
